import { DEFAULT_OPTIONS } from '@pkgs/components/utils/searchStateUtils';
import { Copy } from '@ev-tech/ui-core-components/Copy';
import { Language, PropertyMarketingType } from '@ev-tech/search-modules-api';

import { type RangeInputProps } from './RangeInput.types';
import { RangeInput } from './RangeInput';
import { CurrencyFormattedNumberInput } from './CurrencyFormattedNumberInput';
import { useAppContext } from '../../hooks/useAppContext';

import styles from './RangeInput.module.css';

type PriceInputProps = RangeInputProps & {
  propertyMarketingType: PropertyMarketingType;
  currencySymbol: string;
  language?: Language;
  'data-testid'?: string;
};

export const PriceInput = ({ propertyMarketingType, language, currencySymbol, ...restProps }: PriceInputProps) => {
  const { t } = useAppContext();
  const priceLabel = propertyMarketingType === PropertyMarketingType.rent ? t('search.searchbar.rent') : t('search.searchbar.price');

  const startAdornment = language !== Language.de && <Copy className={styles.endAdornment} as="span" size="l" text={currencySymbol} />;
  const endAdornment = language === Language.de && <Copy className={styles.endAdornment} as="span" size="l" text={currencySymbol} />;

  return (
    <RangeInput
      label={priceLabel}
      id="price"
      inputComponent={
        <CurrencyFormattedNumberInput
          currencySymbol={currencySymbol}
          endAdornment={endAdornment}
          language={language ?? DEFAULT_OPTIONS.language}
          startAdornment={startAdornment}
        />
      }
      {...restProps}
    />
  );
};
